import React, { ReactNode } from 'react';
import { RoundedPlus, Info3 } from '@td-client-frontend/icons';

export interface TemplateEntityProps {
  label?: string;
  showInfoModal?: () => void;
  onAddRowClick?: () => void;
  children?: ReactNode;
  defaultConfig?: any;
}

export const EntityContainer = ({
  label,
  defaultConfig,
  showInfoModal,
  onAddRowClick,
  children
}: TemplateEntityProps) => {
  return (
    <div className="flex flex-col sm:flex-row sm:flex-wrap justify-between w-full bg-white mb-10 last:mb-20">
      <div className="flex flex-col sm:flex-row sm:flex-wrap justify-between py-5 w-full border bg-blue-90 font-medium text-2xl rounded-t">
        <div className="mx-5 text-white">{label}</div>
        <div className="flex gap-5 mx-5 text-base text-white">
          {onAddRowClick && (
            <button className="cursor-pointer flex items-center gap-1 font-medium" onClick={onAddRowClick}>
              <RoundedPlus /> Add row
            </button>
          )}
          {defaultConfig && showInfoModal && (
            <button className="cursor-pointer flex items-center gap-1 font-medium" onClick={showInfoModal}>
              <Info3 /> Defaults
            </button>
          )}
        </div>
      </div>
      {children}
    </div>
  );
};
